module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/feature_2-d7c4e148d902cc7b5d49963777ca2818.png";